import getFeatureFlagValue from './get-feature-flag-value';

const featureFlags = {
  storeSelectorFeatureEnabled: [
    'us',
    'fr',
    'es',
    'de',
    'at',
    'dk',
    'nl',
    'be',
    'se',
    'it',
    'pt',
    'pl',
    'kr',
  ],

  // global store countries that support fulfillment offerings and we want to call f/offs
  globalStoreFoffsEnabled: ['mx'],
};

export const isStoreSelectorFeatureEnabled = getFeatureFlagValue(
  featureFlags,
  'storeSelectorFeatureEnabled',
);

export const isGlobalStoreFoffsEnabled = getFeatureFlagValue(
  featureFlags,
  'globalStoreFoffsEnabled',
);
